// extracted by mini-css-extract-plugin
export var quantityInput = "_e0-0";